import {
  CircuitBoard, FileText, Layers, GitBranch, ClipboardList, History,
  Package, Truck, DollarSign, Shield, Users, Settings,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface NavItem {
  label: string;
  path: string;
  icon: LucideIcon;
}

export interface NavGroup {
  label: string;
  items: NavItem[];
}

export const navGroups: NavGroup[] = [
  {
    label: 'Product Engineering',
    items: [
      { label: 'Circuit Designs', path: '/plm/products', icon: CircuitBoard },
    ],
  },
  {
    label: 'Design Data',
    items: [
      { label: 'Schematics & Docs', path: '/pdm/documents', icon: FileText },
      { label: 'Bill of Materials', path: '/pdm/bom', icon: Layers },
    ],
  },
  {
    label: 'Change Control',
    items: [
      { label: 'Engineering Changes', path: '/ecm/changes', icon: GitBranch },
      { label: 'Change Orders', path: '/ecm/orders', icon: ClipboardList },
      { label: 'Design Revisions', path: '/ecm/revisions', icon: History },
    ],
  },
  {
    label: 'Supply Chain',
    items: [
      { label: 'Component Vault', path: '/erp/inventory', icon: Package },
      { label: 'Supplier Network', path: '/erp/supply-chain', icon: Truck },
      { label: 'Cost Engineering', path: '/erp/finance', icon: DollarSign },
    ],
  },
  {
    label: 'Administration',
    items: [
      { label: 'Admin Dashboard', path: '/admin', icon: Shield },
      { label: 'User Management', path: '/admin/users', icon: Users },
    ],
  },
  {
    label: 'System',
    items: [
      { label: 'Settings', path: '/settings', icon: Settings },
    ],
  },
];
